/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Columnmenu_Sortdesc2Inputs */

const en_columnmenu_sortdesc2 = /** @type {(inputs: Columnmenu_Sortdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort Descending`)
};

const de_columnmenu_sortdesc2 = /** @type {(inputs: Columnmenu_Sortdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Absteigend sortieren`)
};

/**
* | output |
* | --- |
* | "Sort Descending" |
*
* @param {Columnmenu_Sortdesc2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const columnmenu_sortdesc2 = /** @type {((inputs?: Columnmenu_Sortdesc2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Columnmenu_Sortdesc2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_columnmenu_sortdesc2(inputs)
	return de_columnmenu_sortdesc2(inputs)
});
export { columnmenu_sortdesc2 as "columnMenu_sortDesc" }